import { FC } from 'react'
import { Box, Button, Typography } from '@perk-ui/core'
import { Mail } from 'react-feather'

import FormContainer from '../components/FormContainer'
import FormHeader from '../components/FormHeader'

const ContactSupport: FC = () => {
  const handleContactSupport = () => {
    // Open email client with pre-filled support email
    window.location.href =
      'mailto:support@databiologics.com?subject=Provider Access Request&body=Hello,%0D%0A%0D%0AI am an existing staff member who needs provider access to the platform. Please help me with account setup.%0D%0A%0D%0AThank you.'
  }

  return (
    <FormContainer>
      <FormHeader
        title="Contact Support Required"
        description="We need to help you get set up"
      />

      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Box sx={{ mb: 3 }}>
          <Mail size={64} color="#2BADEE" />
        </Box>

        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Additional Setup Needed
        </Typography>

        <Typography
          variant="body1"
          sx={{ mb: 4, color: '#6B7280', maxWidth: '400px', mx: 'auto' }}
        >
          Your account requires special configuration to access the platform.
          Our support team will help you get set up with the appropriate access
          level.
        </Typography>

        <Button
          variant="contained"
          size="large"
          startIcon={<Mail size={16} />}
          onClick={handleContactSupport}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            fontSize: '16px',
            fontWeight: 500,
            px: 4,
            py: 1.5,
          }}
        >
          Contact Support Team
        </Button>

        <Typography variant="body2" sx={{ mt: 3, color: '#9CA3AF' }}>
          Or email us directly at{' '}
          <strong style={{ color: '#2BADEE' }}>
            support@databiologics.com
          </strong>
        </Typography>
      </Box>
    </FormContainer>
  )
}

export default ContactSupport
